export {
  AnimatedEllipsis,
  type AnimatedEllipsisProps,
} from './AnimatedEllipsis';
